import { CdkStep } from '@angular/cdk/stepper';
import { AfterViewInit, Component, ContentChild, ViewEncapsulation } from '@angular/core';
import { MuiWizardStepHeader } from './mui-wizard-step-header.directive';


@Component({
  selector: 'mui-wizard-step',
  styles: [':host { display: block; }'],
  encapsulation: ViewEncapsulation.None,
  exportAs: 'muiWizardStep',
  providers: [{ provide: CdkStep, useExisting: MuiWizardStep }],
  /* For some reason, the inputs of the parent class CdkStep are not properly recognized by the IntelliJ IDE. To prevent
   overriding the original class's implementation, we just declare its inputs here so IntelliJ knows they exist. */
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['label', 'editable', 'completed', 'stepControl'],
  template: `
    <ng-template>
      <ng-content></ng-content>
    </ng-template>
  `
})
export class MuiWizardStep extends CdkStep implements AfterViewInit {
  /** Content for step label given by `<ng-template muiWizardStepLabel>`. */
  @ContentChild(MuiWizardStepHeader) declare stepLabel: MuiWizardStepHeader;

  ngAfterViewInit(): void {
    if (!this.stepLabel && !this.label) {
      console.warn('[MuiWizardStep] No accessible name provided. Please provide a label or use muiWizardStepLabel directive');
    }
  }
}
